import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
  DealerPartNumberResultsRoute,
  DealerTiresizeResultsRoute,
} from "../../../../../navigation/DealerRoutes";
import { useSomeRoutes } from "../../../../../navigation/useSomeRoutes";
import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { KeyValue } from "../../../../../ui/KeyValue/KeyValue";
import { RadioButton } from "../../../../../ui/RadioButton/RadioButton";
import { secondaryTireFilters } from "../secondaryTireFilters";
import { useTireSize } from "./useTireSize";
import { useTireSizeOptions } from "./useTireSizeOptions";

const id = "dealer-tire-size-panel";

export const TireSizeFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, true);
  const { t } = useTranslation();
  const [, setVehicleSubmodelTiresizeId] = useTireSize();
  const tireSizeOptions = useTireSizeOptions();
  const shouldSkip = useSomeRoutes(
    DealerTiresizeResultsRoute,
    DealerPartNumberResultsRoute
  );

  if (shouldSkip) {
    return null;
  }
  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.tireSize")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {tireSizeOptions.map(
        ({
          checked,
          formattedTireSize,
          secondaryFormattedTireSize,
          sizeTypeDescription,
          vehicleSubmodelTiresizeId,
        }) => (
          <label
            className="flex items-center gap-x-4"
            key={vehicleSubmodelTiresizeId}
          >
            <RadioButton
              onChange={(): void => {
                setVehicleSubmodelTiresizeId(
                  vehicleSubmodelTiresizeId,
                  secondaryTireFilters
                );
              }}
              checked={checked}
              checkedClassName="text-selected-tab"
              name="vehicleSubmodelTiresizeId"
              value={vehicleSubmodelTiresizeId}
            />
            <span className="flex-1 w-full">
              {secondaryFormattedTireSize ? (
                <>
                  {sizeTypeDescription}
                  <span className="flex flex-wrap space-x-4 text-xs">
                    <KeyValue>
                      {[t("searchResults.front"), `${formattedTireSize},`]}
                    </KeyValue>
                    <KeyValue className="font-light mr-2">
                      {[t("searchResults.rear"), secondaryFormattedTireSize]}
                    </KeyValue>
                  </span>
                </>
              ) : (
                <>
                  {formattedTireSize} / {sizeTypeDescription}
                </>
              )}
            </span>
          </label>
        )
      )}
    </Collapsible>
  );
};
